import type { ChatMessage } from '@/contexts/chat/scripts/hooks/useChatMessages/types';
import { ChatMessagePayloadType } from '@/contexts/chat/scripts/hooks/useChatMessages/types';
import { ChatMessageStatus } from '@/contexts/chat/scripts/hooks/useChatMessages/types';
import { useChatContext } from '@/contexts/chat/context';
import type { Chat } from '@/contexts/chat/scripts/hooks/useChats/types';
import styles from './index.module.scss';

const VoiceCallText = ({
  status,
  payload_type,
  message,
  children,
  chat,
}: {
  status: ChatMessageStatus;
  payload_type: ChatMessagePayloadType;
  message: ChatMessage;
  children: React.ReactNode;
  chat: Chat;
}) => {
  const { chatMediaCall } = useChatContext();

  const status_ = chatMediaCall.getMediaStatus(
    chatMediaCall.chatMediaInfo,
    message,
    status,
    chat
  );
  const color = useMemo(() => {
    switch (status_) {
      case ChatMessageStatus.CALL_HANG_UP:
        return '';

      case ChatMessageStatus.CALL_TIMEOUT:
      case ChatMessageStatus.CALL_CANCELLED:
      case ChatMessageStatus.CALL_REJECTED:
        // case ChatMessageStatus.CALL_NETWORK_ERROR:
        // case ChatMessageStatus.CALL_BUSY:
        return 'red';

      case ChatMessageStatus.LOADING:
      case ChatMessageStatus.UNREAD:
      case ChatMessageStatus.READ:
      case ChatMessageStatus.CALL_PUT_THROUGH:
        return 'green';

      default:
        return '';
    }
  }, [status_]);

  return (
    <div className={styles.voiceCall}>
      <div className={styles[color]}>
        [
        {payload_type === ChatMessagePayloadType.MEDIA_AUDIO_CALL
          ? 'Voice Call'
          : 'Video Call'}
        ]
      </div>
      <div className={styles.text}>{children}</div>
    </div>
  );
};

export default VoiceCallText;
